export type Bonus = {
  number: number
  title: string
  shortTitle: string
  what: string
  whyLead: string
  whyPoints: string[]
  whyClose: string
  includes: string[]
  result: string[]
  value: number
  image: string
  imageAlt: string
}

export const bonusesIntro = {
  headline: 'Espera. Antes de empezar, necesitas estas 3 herramientas.',
  subheadline:
    'Sin ellas, vas a estar adivinando qué hacer. Con ellas, vas a tener claridad total desde el Día 1.',
  body: [
    'Mira, el problema no es que no sepas bajar la barriga. El problema es que no sabes por qué está inflamada.',
    '¿Es aire? ¿Digestión lenta? ¿Retención? ¿Estrés? ¿Todo junto?',
    'Sin saber esto, puedes seguir el protocolo de 7 días y aún así no ver los cambios que esperas. Por eso creamos estos 3 bonos exclusivos.',
  ],
  emphasis:
    'No son relleno. Son herramientas que van a acelerar tu progreso y darte claridad desde el minuto uno.',
  image: 'https://cdn.magicpatterns.com/uploads/5PpdBTBCdMZpQHMuq1HeKY/BONO_1.png',
  imageAlt: 'Mujer sonriendo en su cocina con un vaso de agua con limón y la mano sobre el abdomen',
}

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: 'Mapa Antihinchazón de 7 Minutos',
    shortTitle: 'Mapa Antihinchazón de 7 Minutos',
    what: 'Un test rápido + mapa de identificación que te ayuda a descubrir exactamente qué tipo de inflamación abdominal tienes.',
    whyLead: 'Porque no todas las mujeres se inflan por las mismas razones.',
    whyPoints: ['Una por gases.', 'Otra por digestión lenta.', 'Otra por retención.', 'Otra por estrés.'],
    whyClose:
      'Si no identificas cuál es TU caso, vas a estar haciendo un protocolo genérico.',
    includes: [
      'Test de 7 minutos',
      'Las 4 causas principales de hinchazón explicadas',
      'Checklist de detonantes específicos',
      'Ajuste recomendado de 24 horas según tu resultado',
      'Hoja printable para guardar',
    ],
    result: [
      'Después de hacer este test, vas a saber exactamente qué cambiar hoy mismo. No mañana. Hoy.',
      'Y eso es poderoso porque vas a sentir diferencia en 24 horas.',
    ],
    value: 27,
    image: 'https://cdn.magicpatterns.com/uploads/4pUw8aEkSGAVtwChtNZroe/BONO_1.2.png',
    imageAlt: 'Portada del Mapa Antihinchazón: mujer en la cocina con las manos sobre el abdomen',
  },
  {
    number: 2,
    title: 'Checklist Cero Barriga de Globo',
    shortTitle: 'Checklist Cero Barriga de Globo',
    what: 'Una checklist diaria para los 7 días que te muestra exactamente qué revisar en la mañana, tarde y noche para evitar los errores invisibles que te inflan.',
    whyLead: 'Porque los errores que más te inflan son los que no ves venir.',
    whyPoints: [
      'Comer rápido sin darte cuenta.',
      'Tomar agua con gas sin acordarte.',
      'Cenar tarde sin pensar en ello.',
      'Dormir mal sin planearlo.',
    ],
    whyClose:
      'Estos errores pequeños se suman durante el día y terminan inflamándote completamente.',
    includes: [
      'Checklist de mañana (8 puntos)',
      'Checklist de tarde (8 puntos)',
      'Checklist de noche (8 puntos)',
      'Semáforo abdominal: verde, amarillo, rojo',
      'Tracker de 7 días para medir tu progreso',
      '12 errores invisibles que debes evitar',
      'Hoja printable para pegar en la nevera',
    ],
    result: [
      'Cada mañana vas a saber exactamente qué revisar. Cada tarde vas a evitar los detonantes sin pensar. Cada noche vas a preparar tu cuerpo para amanecer más liviana.',
      'Al final del día marcas un color: verde, amarillo o rojo. Eso te muestra patrones en 7 días que de otra forma no ves en 7 meses.',
    ],
    value: 27,
    image: 'https://cdn.magicpatterns.com/uploads/opn28mPgvRbsnhTXGXoWmx/BONO_1.3.png',
    imageAlt: 'La checklist mostrada en tablet, computadora y celular sobre una encimera de mármol',
  },
  {
    number: 3,
    title: 'Menú SOS Anti-Inflamación: 21 Combinaciones Rápidas',
    shortTitle: 'Menú SOS Anti-Inflamación',
    what: '21 comidas simples, rápidas y ligeras para los 7 días. Sin complicarse. Sin recetas gourmet. Sin morirse de hambre.',
    whyLead: 'Porque «¿y qué voy a comer?» es la pregunta que más mata la motivación.',
    whyPoints: [
      'Tienes que trabajar.',
      'Tienes que cuidar a tu familia.',
      'Tienes que tener energía.',
      'No tienes 2 horas para cocinar.',
    ],
    whyClose: 'Y tampoco quieres vivir a punta de ensalada triste.',
    includes: [
      '7 desayunos antiinflamación',
      '7 almuerzos ligeros',
      '7 cenas digestivas',
      'La fórmula del plato liviano (proteína + carbohidrato + vegetal + grasa pequeña)',
      'Lista de compras express',
      'Tabla de sustituciones (si no tienes un ingrediente)',
      'Guía para comer sin inflarte',
      'Planeador imprimible de 7 días',
    ],
    result: [
      'Mañana cuando despiertes, ya sabes qué desayunar. En la tarde, ya tienes 7 opciones de almuerzo claras. En la noche, ya sabes qué cocinar. No tienes que pensar: solo cocinar y comer.',
      'Todas las comidas están diseñadas para ayudarte a sentirte más liviana, no para castigarte.',
    ],
    value: 27,
    image: 'https://cdn.magicpatterns.com/uploads/k3icHHHaNbenysnibCx3Tc/1.3_.png',
    imageAlt: 'El Menú SOS Anti-Inflamación en computadora, tablet y celular junto a jengibre y agua con pepino',
  },
]

export const ctaOptions = {
  directo: {
    label: 'Sí, quiero todo por $7.99',
    sub: 'Vientre Plano Express + 3 bonos (valor $81) + acceso inmediato',
  },
  urgencia: {
    label: 'Acceder ahora — Lanzamiento $7.99',
    sub: 'Después de hoy, el precio sube. Garantizado.',
  },
  emocional: {
    label: 'Empezar con claridad hoy — $7.99',
    sub: 'Lleva todo: protocolo + 3 bonos. Acceso en segundos.',
  },
  apremiante: {
    label: 'No esperes — $7.99 solo hoy',
    sub: 'Mañana el precio sube. Esta oferta es por 48 horas solamente.',
  },
}
